module.exports = __webpack_public_path__ + "img/Friend_Home_Desktop.jpg";